var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMessage48Filled = function SvgIconMessage48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.44 10.53h-18.8a5.08 5.08 0 0 0-5.08 5.07v19.19a2.69 2.69 0 0 0 1.64 2.47 2.72 2.72 0 0 0 1 .21 2.67 2.67 0 0 0 1.87-.77l4.48-4.42H33.4a5.08 5.08 0 0 0 5.07-5.07V15.6a5.08 5.08 0 0 0-5.03-5.07ZM19.17 22.6a1.7 1.7 0 0 1-2.4-2.4 1.7 1.7 0 0 1 2.4 2.4Zm6.07 0a1.7 1.7 0 1 1-2.41-2.401 1.7 1.7 0 0 1 2.41 2.4Zm6.06 0a1.68 1.68 0 0 1-2.4 0 1.7 1.7 0 1 1 2.4-2.4 1.681 1.681 0 0 1 0 2.4Z",
    fill: "current"
  })));
};
export default SvgIconMessage48Filled;